import { createContext } from 'react';

const SectionContext = createContext({
	section: null,
});

export default SectionContext;
